import {TemplateList} from '~/libs/constants/TemplateList'
import {useUniWebTemplate} from '~/composables/useUniWebTemplate'

export function useCanonical() {
  const template = useUniWebTemplate()
  const route = useRoute()

  if (template.uniWebTemplateNameLowerCase !== TemplateList.HEYFOMO) {
    return
  }

  useHead({
    link: [
      {rel: 'canonical', href: computed(() => new URL(route.path, 'https://heyfomo.cz').href)}
    ]
  })
}
